import React, { Component } from 'react';
import PropTypes from 'prop-types';
import '../../../styles/scss/style.css';

//Components
import LabeledTextfield from '../molecules/LabeledTextfield';
import LabeledSelect from '../molecules/LabeledSelect';
import SectionDivider from '../molecules/SectionDivider';
import TextParagraph from '../atoms/TextParagraph';

//Returning the component
class FormBillingInformation extends Component {
	render() {
		return (
			<div className="formBillingInformation margin-b-md">
				<SectionDivider heading="Billing information" />
				<TextParagraph classType="margin-b-sm" text="Sed ut perspiciatis unde omnis iste natus error sit voluptatem accusantium doloremque laudantium, totam rem aperiam, eaque ipsa quae ab illo inventore veritat.."/>
				<form onSubmit={this.props.handleFormSubmit} className={`form ${this.props.formWrapperClassType}`}>
					<div className="row">
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Full name */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="fullname"
								labelText="Fullname"
								labelId="fullname"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="fullname"
								textfieldPlaceholder={this.props.fullname}
								textfieldName='fullnameInput'
								textfieldOnChange={this.props.fullnameOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageFullname}
								required={true}
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Street */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="street"
								labelText="Street"
								labelId="street"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="street"
								textfieldPlaceholder={this.props.street}
								textfieldName='streetInput'
								textfieldOnChange={this.props.streetOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageStreet}
								required={true}
							/>
						</div>

						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* City */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="city"
								labelText="City"
								labelId="city"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="city"
								textfieldPlaceholder={this.props.city}
								textfieldName='cityInput'
								textfieldOnChange={this.props.cityOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCity}
								required={true}
							/>
						</div>

						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Postal Code */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								inputType="number"
								labelFor="postalCode"
								labelText="Postal code"
								labelId="postalCode"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="postalCode"
								textfieldPlaceholder={this.props.postalCode}
								textfieldName='postalCodeInput'
								textfieldOnChange={this.props.postalCodeOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessagePostalCOde}
								required={true}
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Country */}
							<LabeledSelect
								formGroupClassType={this.props.formGroupClassType}
								labelFor="country"
								labelText="Country"
								labelId="country"
								selectClassType={this.props.textfieldClassType}
								selectId="country"
								selectName="country"
								selectChildren="Country"
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageCountry}
								selectRequired="required"
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* Postal Code */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="province"
								labelText="State/Province"
								labelId="province"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="province"
								textfieldPlaceholder={this.props.province}
								textfieldName='provinceInput'
								textfieldOnChange={this.props.provinceOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageProvince}
								required={true}
							/>
						</div>
						<div className="col-sm-12 col-md-6 col-lg-4">
							{/* email */}
							<LabeledTextfield
								formGroupClassType={this.props.formGroupClassType}
								labelFor="email"
								labelText="email"
								labelId="email"
								textfieldClassType={this.props.textfieldClassType}
								textfieldId="email"
								textfieldPlaceholder={this.props.email}
								textfieldName='emailInput'
								textfieldOnChange={this.props.emailOnChange}
								errorMessageClassType={this.props.errorMessageClassType}
								errorMessageText={this.props.errorMessageEmail}
								required={true}
							/>
						</div>
					</div>
				</form>
			</div>
		)
	}
}

//Making sure that it has a text property when it's declared
FormBillingInformation.propTypes = {
	test: PropTypes.string, //Write some props here if needed, just using this to not have errors
}

export default FormBillingInformation;


// WEBPACK FOOTER //
// ./src/redux/components/organisms/FormBillingInformation.jsx